import { render } from "./InventoryCard.vue?vue&type=template&id=687b6e9d"
import script from "./InventoryCard.vue?vue&type=script&lang=js"
export * from "./InventoryCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__